import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=847b1c00"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('847b1c00')) {
      api.createRecord('847b1c00', component.options)
    } else {
      api.reload('847b1c00', component.options)
    }
    module.hot.accept("./PdfViewer.vue?vue&type=template&id=847b1c00", function () {
      api.rerender('847b1c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/PdfViewer.vue"
export default component.exports